export var input = '$_3K8GY';